import get from 'lodash/get';
import React from 'react';

import { useComposablePage } from '../../../../helpers/composable';
import withBrandedComposablePage from '../../../../hocs/withBrandedComposablePage';
import ComposablePageLayout from '../../../../layouts/ComposablePageLayout';
import MediaPageQuery from './MediaPage.gql';
import pageData from './MediaPage.json';
import errorPageData from './MediaPageNotFound.json';

const MediaPage = () => {
  const { render } = useComposablePage();
  const content = render(pageData, errorPageData);

  return <ComposablePageLayout>{content}</ComposablePageLayout>;
};

export default withBrandedComposablePage({
  query: MediaPageQuery,
  isFound: (data) => get(data, 'brand.media'),
})(MediaPage);
